module.exports = __webpack_public_path__ + "img/empty.ba823ee3.png";